import React from 'react';
import { problemPoints } from '../../data/mock';

const ProblemSection = () => {
  return (
    <section
      id="problem"
      className="py-16 sm:py-20 lg:py-24 relative overflow-hidden bg-slate-900"
      data-testid="problem-section"
    >
      <div className="absolute top-0 right-0 w-72 h-72 bg-orange-600/10 rounded-full blur-3xl" aria-hidden="true"></div>
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-blue-600/10 rounded-full blur-3xl" aria-hidden="true"></div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-10 sm:mb-14">
          <span className="inline-block px-4 py-2 bg-orange-500/10 border border-orange-500/30 rounded-full text-orange-400 text-sm font-medium mb-4">
            Real Concerns
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            Does Any of This Sound Like You?
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 max-w-6xl mx-auto">
          {problemPoints.map((point, i) => (
            <div
              key={i}
              className="bg-slate-800/50 backdrop-blur-sm rounded-2xl p-6 border border-slate-700/50 hover:border-blue-500/40 transition-colors"
              data-testid={`problem-card-${i}`}
            >
              <div className="text-4xl mb-4" aria-hidden="true">{point.emoji}</div>
              <p className="text-slate-300 text-sm sm:text-base leading-relaxed">
                {point.text}
              </p>
            </div>
          ))}
        </div>

        <p className="text-center text-slate-300 text-base sm:text-lg mt-10 max-w-3xl mx-auto leading-relaxed">
          You're in the right place. Our <span className="text-emerald-400 font-semibold">doctor-guided approach</span> is built to support people at every stage of life.
        </p>
      </div>
    </section>
  );
};

export default ProblemSection;
